(function() {
  window.onload = function() {
    "use strict";

    const urlParams = new URLSearchParams(window.location.search);
    const activeSection = urlParams.get('section');

    // Server data
    var app = {};

    var days = [];
    var daysEn = ['Sun','Mon','Tue','Wed','Thu','Fri', 'Sat'];
    var daysIs = ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'];

    if(window.language_code == "is") {
      days = daysIs;
    } else {
      days = daysEn;
    }

    Date.prototype.getDayName = function() {
        const weekDay = this.getDay()
        return days[weekDay];
    };

    function getFormattedDate(date) {
      const splitDate = date.substring(1).split('/');
      const dateObj = new Date()
      dateObj.setYear(splitDate[2]);
      dateObj.setMonth(splitDate[1] - 1);
      dateObj.setDate(splitDate[0]);
      return dateObj.getDayName() + ' ' + dateObj.getDate() + '.' + (dateObj.getMonth() + 1);
    }

    function showSpinnerWhileIFrameLoads() {
      var iframe = $('iframe');
      if (iframe.length) {
          $(iframe).wrap('<div class="iframe-wrapper"></div>');
          $(iframe).before('<div class=\'loading-frame\'><i class="spinner"></i></div>');
          $(iframe).on('load', function() {
            $(this).prev('.loading-frame').hide();
          });
      }
    }

    function setupDropdownLists() {
      var dropdown = $('.dropdown-list');
      dropdown.find('.dropdown-span').html(dropdown.find(":selected").text());
      if (dropdown.length) {
        dropdown.on('change', function() {
          dropdown.find('.dropdown-span').html($(this).find(":selected").text());
        });
      }
    }

    function updateQueryStringParameter(uri, key, value) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = uri.indexOf('?') !== -1 ? "&" : "?";
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
      }
      else {
        return uri + separator + key + "=" + value;
      }
    }

    // Self executing function to start the app
    (function() {
      // Copy server data
      Object.assign(app, {
        locations: JSON.parse(atob(window.locations)),
        regions: {},
        server_data: JSON.parse(atob(window.server_data)),
        currentCityId: undefined,
        currentCityData: undefined,
        citiesById: {},
        picturesByCity: {},
        selectCity: document.querySelector(".select-city"),
        activeLocationId: undefined
      });

      // Initialize location id
      app.activeLocationId = getActiveLocationId();

      // Add regions to (select) menu
      var rawRegions = {};
      app.locations.forEach(function(l) {
        if (!(l["region"] in rawRegions)) {
          rawRegions[l["region"]] = [];
        }
        rawRegions[l["region"]].push(l);
      });

      // Sort regions alphabetically
      Object.keys(rawRegions)
        .sort()
        .forEach(function(key) {
          app.regions[key] = rawRegions[key];
        });

      // Construct the city menu
      for (let regionName in app.regions) {
        var optGr = document.createElement("optgroup");
        optGr.setAttribute("label", regionName);

        app.regions[regionName].forEach(function(l) {
          var option = document.createElement("option");

          option.textContent = l.name;

          option.dataset.region = regionName;
          option.dataset.embeds = JSON.stringify(l.embeds);
          option.dataset.slug = l.slug;

          option.setAttribute("value", l.location_id);

          if (app.activeLocationId == l.city_id) {
            option.setAttribute("selected", true);
          }

          optGr.appendChild(option);

          app.citiesById[l.location_id] = l.name;
        });

        app.selectCity.appendChild(optGr);
      }

      // Select right city
      app.selectCity.value = app.activeLocationId;

      // Activate a city and set up
      // Other Cities list
      const cityData = {
        cityID: app.activeLocationId,
        cityName: app.citiesById[app.activeLocationId]
      };

      if ("yrXML" in app.server_data) {
        Object.assign(cityData, { yrXML: app.server_data.yrXML });
      }

      fetchWeatherData(cityData, true, setupHeaderMenu);

      // Start Other Cities list
      updateOtherCities();

      if (document.querySelector("main.home")) {
        // Get general weather info
        var extra = document.querySelector(".extra-content");
        api(
          "weather",
          function(response) {
            var parser = new DOMParser(),
              xmlDoc = parser.parseFromString(response.trim(), "text/xml"),
              title = xmlDoc.getElementsByTagName("title")[0],
              content = xmlDoc.getElementsByTagName("content")[0];
            extra.querySelector(".title").innerText = title.innerHTML;
            extra.querySelector(".content").innerHTML = content.innerHTML;
          },
          { language_code: window.language_code }
        );
      }
    })();

    // Get translation
    function __(string) {
      if (window.language_code == "en") return string;

      if (window.language_code == "is") {
        const translations = {
          Quiet: "Lítil virkni",
          Medium: "Aukin virkni",
          High: "Mikil virkni",
          "Very High": "Mjög mikil virkni"
        };
        return string in translations ? translations[string] : string;
      }
    }

    // Get lang string
    function _lang() {
      return window.language_code != "en"
        ? "?lang=" + window.language_code
        : "";
    }

    // REST API access
    function api(type, callback, extraParams) {
      if (!type && typeof type !== "string") {
        return;
      }
      var xhr = new XMLHttpRequest(),
        params = {
          token: window.token,
          type: type
        };
      // In case extra parameters are available, use them
      if (extraParams) {
        params = Object.assign(params, extraParams);
      }
      xhr.open("POST", "/rest");
      xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
      xhr.onload = function() {
        // Check if request worked
        if (xhr.status !== 200) {
          console.log("Request failed. Returned status of " + xhr.status);
          return;
        }

        if (!xhr.responseText) {
          console.error("API: Invalid response");
          return;
        }

        // Execute callback if needed
        if (callback) {
          callback(xhr.responseText);
        }
      };
      xhr.send(JSON.stringify(params));
    }

    // Update interface with new weather data
    function updateWeatherInterface(data) {
      var quickWeatherBox = document.querySelector(".quick-weather");

      // Update city name
      var currentCity = document.querySelector(".current-location-city");
      currentCity.innerText = data.cityName;

      // Get slider template to start creating the new ones
      const slideTemplate = quickWeatherBox.querySelector(".slide");

      // Quick check
      if (!Array.isArray(data.quickWeather))
        throw "quickWeather must be an array";

      // Keep this for later use on detailed view
      const originalData = [...data.quickWeather];

      // If data is coming from YR filter it so that we
      // only show one slider per day on the overview
      if (data.quickWeather.length > 1) {
        data.quickWeather = data.quickWeather.filter((day, index) => {
          return day.period === "2" || (day.period === "3" && index === 0)
            ? true
            : false;
        });
      }

      const detailedWetherBtn = document.querySelector(".btn-detailed")

      detailedWetherBtn.addEventListener("click", () => {
        _setupDetailedWeather(originalData, data.cityName).then(() => {
          // GEt weather details modal element
          const detailedWeather = document.querySelector(
            ".detailed-weather"
          );

          // Show modal
          detailedWeather.classList.add("active");
          setTimeout(function() {
            detailedWeather.classList.add("visible");
          }, 10);

          // Lock scroll on body
          document.body.style.overflowY = "hidden";
        });
      });

      // Create a slider for each data point
      data.quickWeather.forEach(item => {
        // Get all the information elements
        const slide = slideTemplate.cloneNode(true),
          currentTemp = slide.querySelector(".current-temperature-digit"),
          windSpeed = slide.querySelector(".wind-speed"),
          windDirection = slide.querySelector(".wind-info .compass"),
          weatherIcon = slide.querySelector(".icon.weather"),
          dateWrapper = slide.querySelector(".date span");

        // Set temperature
        currentTemp.innerText = item.temperature;

        // Set wind speed
        windSpeed.innerText = item.wind.speed;

        // Set wind direction icon/direction
        windDirection.style =
          "transform: rotate(" + (item.wind.deg - 180) + "deg);";

        // Set icon according to weather
        // If using YR.no the icons come from there
        // If not use local icons (inside theme)
        weatherIcon.style = `background-image: url(${item.icon});`;

        // Set date for which this item is good f;or
        dateWrapper.innerText = getFormattedDate(item.date);

        // The slide template comes with a hidden attribute
        // which we must remove before adding it to the DOM
        slide.removeAttribute("hidden");

        // Add slide to DOM
        quickWeatherBox.querySelector(".slider").append(slide);
      });

      // After all slides are in place start Slick Slider
      $(quickWeatherBox.querySelector(".slider")).slick({
        arrows: false,
        // Only show dots if there is more than one slide
        // If using OpenWeahter.org source there's one data point
        dots: data.quickWeather.length > 1 ? true : false
      });

      const detailedWeatherBackBtn = document.querySelector(
        ".detailed-weather .btn-back"
      );
      detailedWeatherBackBtn.addEventListener("click", () => {
        // Get weather details modal element
        const detailedWeather = document.querySelector(".detailed-weather");

        // Show modal
        detailedWeather.classList.remove("visible");
        setTimeout(function() {
          detailedWeather.classList.remove("active");
        }, 510);

        // Unlock scroll on body
        document.body.style.overflowY = "auto";
      });

      const selectForecastType = $('#forecastType');

      selectForecastType.on('change', function() {
          const cityData = {
            cityID: app.activeLocationId,
            cityName: app.citiesById[app.activeLocationId]
          };

          if ("yrXML" in app.server_data) {
            Object.assign(cityData, { yrXML: app.server_data.yrXML });
          }

          if(this.value === 'h') {
            if(app.currentCityData.hourlyWeather) {
              loadHourlyData();
            } else {
              fetchHourlyWeatherData(cityData, loadHourlyData);
            }
          } else if(this.value === 'd') {
            loadDailyData();
          }
      });

      // Remove the loading class (currently just hides the dashboard)
      setTimeout(function() {
        var dashboard = document.querySelector(".page-header .dashboard");
        dashboard.classList.remove("loading");
      }, 1300);

      function _setupDetailedWeather(days, location) {
        return new Promise(function(resolve) {
          const detailedWeather = document.querySelector(".detailed-weather");

          // Update the location name
          detailedWeather.querySelector(".location").innerHTML = location;

          app.currentCityData.detailedWeather = days;

          renderDetailedWeatherList(days);

          resolve();
        });
      }
    }

    // UPdate interface with new background picture
    function updateBackgroundInterface(imgURL) {
      if (!imgURL) {
        // No image found for this city, use random fallback
        var rand = Math.floor(1 + Math.random() * 5);
        imgURL = {
          large: "/wp-content/themes/weather/img/iceland/iceland_%s.jpg".replace(
            "%s",
            rand
          ),
          medium: "/wp-content/themes/weather/img/iceland/iceland_medium_%s.jpg".replace(
            "%s",
            rand
          )
        };
      }
      var backgroundContainer = document.querySelector(
        ".page-header .background .img-box"
      );
      var pictureDOM = backgroundContainer.querySelector("picture");
      pictureDOM
        .querySelector("source")
        .setAttribute("srcset", imgURL["large"]);
      pictureDOM.querySelector("img").setAttribute("src", imgURL["medium"]);

      setTimeout(function() {
        var background = document.querySelector(
          ".page-header .background .img-box"
        );
        background.classList.remove("loading");
      }, 1300);
    }

    // Get picture for background image and update interface
    // Gets picture from Flickr group "Project Weather"
    // https://www.flickr.com/groups/projectweather/
    function setupBackgroundImage(data) {
      // Fallback images for auroras
      if (data.city == "aurora") {
        updateBackgroundInterface({
          large: "/wp-content/themes/weather/img/aurora_large.jpg",
          medium: "/wp-content/themes/weather/img/aurora.jpg"
        });
        return;
      }

      // Use images alerady saved to update bg image
      if (app.currentCityId in app.picturesByCity) {
        var cityPics = app.picturesByCity[app.currentCityId];
        updateBackgroundInterface(
          cityPics[Math.floor(Math.random() * cityPics.length)]
        );
        return;
      }

      // Get pictures from DB/API
      var params = {
        photoQuery: data.city // City name
      };
      api(
        "flickrPicSet",
        function(response) {
          var response = JSON.parse(response),
            photos = response.photos.photo,
            picIds = [];

          for (var i = 0; i < photos.length; i++) {
            picIds.push(photos[i].id);
          }
          var params = {
            picIds: picIds,
            city: app.currentCityId
          };
          api(
            "flickrPics",
            function(imgsData) {
              var imgsData = JSON.parse(imgsData);

              // Keep city's images URLs
              app.picturesByCity[app.currentCityId] = [];
              for (var i = 0; i < imgsData.length; i++) {
                var imgData = imgsData[i];

                if (!imgData) continue;

                if (!("sizes" in imgData)) {
                  return;
                }
                var large1600 = imgData.sizes.size.filter(function(s) {
                  return s.label == "Large 1600";
                });
                if (!large1600.length) {
                  var large = imgData.sizes.size.filter(function(s) {
                    return s.label == "Large";
                  });
                }
                var largeURL = large1600.length
                  ? large1600[0].source
                  : large[0].source;

                var medium800 = imgData.sizes.size.filter(function(s) {
                  return s.label == "Medium 800";
                });
                if (!medium800.length) {
                  var medium = imgData.sizes.size.filter(function(s) {
                    return s.label == "Medium";
                  });
                }
                var mediumURL = medium800.length
                  ? medium800[0].source
                  : medium[0].source;

                app.picturesByCity[app.currentCityId].push({
                  large: largeURL,
                  medium: mediumURL
                });
              }

              // Load random picture
              var cityPics = app.picturesByCity[app.currentCityId];
              updateBackgroundInterface(
                cityPics[Math.floor(Math.random() * cityPics.length)]
              );
            },
            params
          );
        },
        params
      );
    }

    function fetchHourlyWeatherData(cityData, callback) {
      var params = {};
      if ("yrXML" in cityData) {
        params = Object.assign(params, {
          yrXML: cityData.yrXML.replace('forecast.xml', 'forecast_hour_by_hour.xml')
        });
      } else if ("cityID" in cityData) {
        params = Object.assign(params, {
          cityID: cityData.cityID
        });
      }

      api(
        "weatherCity",
        function(response) {
          // Prepare data to be used on interface
          if ("yrXML" in cityData) {
            const parser = new DOMParser(),
              data = parser.parseFromString(response.trim(), "text/xml"),
              days = data.querySelectorAll("time");

            app.currentCityData.hourlyWeather = [...days].map(day => {
              const date = new Date(day.getAttribute("from"));

              return {
                temperature: day
                  .querySelector("temperature")
                  .getAttribute("value"),
                precipitation: day
                  .querySelector("precipitation")
                  .getAttribute("value"),
                icon: `https://${window.location.hostname}/wp-content/themes/weather/img/weather-symbols/100/${day
                  .querySelector("symbol")
                  .getAttribute("var")}.png`,
                wind: {
                  speed: day.querySelector("windSpeed").getAttribute("mps"),
                  deg: day.querySelector("windDirection").getAttribute("deg")
                },
                date: formatDate(date),
                time: `${("0" + date.getHours()).slice(-2)}:${(
                  "0" + date.getMinutes()
                ).slice(-2)}`,
                period: day.getAttribute("period")
              };
            });
          }

          // Sometimes there's a callback to this action
          if (callback) {
            callback();
          }
        },
        params
      );
    }

    // Fetch new weather data
    function fetchWeatherData(cityData, dispatchMenuClick, callback) {
      var params = {};
      if ("yrXML" in cityData) {
        params = Object.assign(params, {
          yrXML: cityData.yrXML
        });
      } else if ("cityID" in cityData) {
        params = Object.assign(params, {
          cityID: cityData.cityID
        });
      }

      // Change current city reference
      app.currentCityId = cityData.cityID;

      api(
        "weatherCity",
        function(response) {
          // Prepare data to be used on interface
          if ("yrXML" in cityData) {
            const parser = new DOMParser(),
              data = parser.parseFromString(response.trim(), "text/xml"),
              days = data.querySelectorAll("time");

            app.currentCityData = {
              cityId: cityData.cityID,
              cityName: cityData.cityName,
              quickWeather: [...days].map(day => {
                const date = new Date(day.getAttribute("from"));

                return {
                  temperature: day
                    .querySelector("temperature")
                    .getAttribute("value"),
                  precipitation: day
                    .querySelector("precipitation")
                    .getAttribute("value"),
                  icon: `https://${window.location.hostname}/wp-content/themes/weather/img/weather-symbols/100/${day
                    .querySelector("symbol")
                    .getAttribute("var")}.png`,
                  wind: {
                    speed: day.querySelector("windSpeed").getAttribute("mps"),
                    deg: day.querySelector("windDirection").getAttribute("deg")
                  },
                  date: formatDate(date),
                  time: `${("0" + date.getHours()).slice(-2)}:${(
                    "0" + date.getMinutes()
                  ).slice(-2)}`,
                  period: day.getAttribute("period")
                };
              })
            };
          } else if ("cityID" in cityData) {
            var response = JSON.parse(response);

            const now = new Date();
            app.currentCityData = {
              cityId: cityData.cityID,
              cityName: cityData.cityName,
              quickWeather: [
                {
                  temperature: Math.round(response.main.temp, -1),
                  icon: `/wp-content/themes/weather/img/weather/${response.weather[0].icon}.svg`,
                  wind: response.wind,
                  date: formatDate(now)
                }
              ]
            };
          }

          // Once the weather data is ready update the interface accordingly
          updateWeatherInterface(app.currentCityData);

          // Sometimes this flag is passed to update the page content
          // for currently active section (Forecast, Roads, etc)
          if (dispatchMenuClick) {
            var event = new Event("click"),
              activeMenuItem = document.querySelector(".header-menu li.active");
            if (activeMenuItem) {
              activeMenuItem.dispatchEvent(event);
            } else {
              var firstMenuItem = document.querySelector(".header-menu li");
              // If this condition is not satisfied the header image will
              // never show
              if (firstMenuItem) {
                firstMenuItem.dispatchEvent(event);
              }
            }
          }

          // Sometimes there's a callback to this action
          if (callback) {
            callback();
          }
        },
        params
      );
    }

    // Update "other cities" list
    function updateOtherCities() {
      var activeOption = app.selectCity.querySelector(":checked"),
        allCitiesInRegion = app.selectCity.querySelectorAll(
          '[data-region="' + activeOption.dataset.region + '"]:not(:checked)'
        ),
        otherCities = document.querySelector(".other-cities");

      if (!otherCities) return;

      var otherCitiesList = otherCities.querySelector(".other-cities-list");

      // Resolve list display setting
      otherCities.style.display = allCitiesInRegion.length ? "block" : "none";

      // If there are no other cities in region just return
      if (!allCitiesInRegion.length) {
        return;
      }

      otherCitiesList.innerHTML = "";

      for (var i = 0; i < allCitiesInRegion.length; i++) {
        var city = allCitiesInRegion[i],
          li = document.createElement("li"),
          a = document.createElement("a");

        a.href = "/iceland/" + city.dataset.slug + "/" + _lang();
        a.innerHTML = city.innerHTML;

        li.appendChild(a);
        otherCitiesList.appendChild(li);
      }
    }

    // Setup city change trigger
    app.selectCity.addEventListener("change", function() {
      window.location =
        "/iceland/" +
        this.querySelector("option:checked").dataset.slug +
        _lang();
    });

    function renderDetailedWeatherList(days) {
      const detailedWeather = document.querySelector(".detailed-weather"),
      itemTemplate = detailedWeather.querySelector(".item-template");

      // Remove all existing items
      detailedWeather
        .querySelectorAll(".item:not(.item-template)")
        .forEach(i => i.parentNode.removeChild(i));

      $("#meteogram").remove();

      // Add each item
      days.forEach(day => {
        const item = itemTemplate.cloneNode(true);
        // Populate item with data about this day          
        item.querySelector(".date").innerHTML = getFormattedDate(day.date);
        item.querySelector(".time").innerHTML = day.time;
        item.querySelector(".icon").src = day.icon;
        item.querySelector(".temperature").innerHTML = day.temperature;
        item.querySelector(".precipitation").innerHTML = day.precipitation;
        item.querySelector(".wind-speed").innerHTML = day.wind.speed;
        item.querySelector(".compass").style.transform =
          "rotate(" + (parseFloat(day.wind.deg) - 180) + "deg)";

        // Do class handling
        item.classList.remove("item-template");
        item.classList.add("item");
        item.removeAttribute("hidden");

        // Add item to list
        detailedWeather.querySelector(".details").appendChild(item);

      });

      if ("yrXML" in app.server_data) {
        var img = $('<img />', { 
          id: 'meteogram',
          src: app.server_data.yrXML.replace('forecast.xml', 'meteogram.svg'),
          alt: 'meteogram'
        });
        $("ul.details").append(img);
        //app.server_data.yrXML.replace('forecast.xml', 'forecast_hour_by_hour.xml');
      }

    }

    function loadHourlyData() {
      const days = app.currentCityData.hourlyWeather;
      renderDetailedWeatherList(days);
    }

    function loadDailyData() {
      const days = app.currentCityData.detailedWeather;
      renderDetailedWeatherList(days);
    }

    // Setup header menu (map types and aurora)
    function setupHeaderMenu() {
      if (!document.querySelector(".header-menu")) return;

      var menuItems = document.querySelectorAll(".header-menu li"),
        menuItemsCount = 0;

      menuItems.forEach(item => {
        // Add event listener for each menu item
        item.addEventListener("click", onMenuItemClick);

        menuItemsCount++;

        // Once all items are set up trigger
        // a click event in the first menu item
        if (menuItemsCount == menuItems.length) {
          var event = new Event("click");
          menuItems[0].dispatchEvent(event);
        }
      });

      const activeMenuElement = document.getElementById(activeSection);

      if(activeMenuElement) {
        activeMenuElement.click();
      }

    }

    function onMenuItemClick(e) {
      e.preventDefault();

      // Return if clicked section is already active
      if (this.classList.contains("active")) {
        return;
      }

      // Mark item as active
      var activeItem = this.parentNode.querySelector(".active");
      if (activeItem) {
        activeItem.classList.remove("active");
      }
      this.classList.add("active");

      var newurl = updateQueryStringParameter(window.location.href,'section', this.dataset.type);
      window.history.pushState({path:newurl},'',newurl);

      // Background image exception for Auroras
      if (this.querySelector("a").innerText.toLocaleLowerCase() == "aurora") {
        setupBackgroundImage({ city: "aurora" });
      } else if (app.currentCityData) {
        setupBackgroundImage({ city: app.currentCityData.cityName });
      }

      // Clear avalanche section (TODO: Improve, and while you're at it improve everything)
      var avalancheAlerts = document.querySelector(".avalanche-alerts");
      avalancheAlerts.setAttribute("hidden", true);

      // Change page content based on city and section type
      // (exception for Aurora section, which shows
      // the same content for all cities)
      if (this.dataset.type == "aurora") {
        api("aurora", function(response) {
          setupAurora(response);
        });
      } else {
        var embedBox = document.querySelector(".embed-box"),
          activeOption = app.selectCity.querySelector(
            'option[value="' + app.activeLocationId + '"]'
          ),
          embeds = JSON.parse(activeOption.dataset.embeds);

        embedBox.innerHTML = embeds[this.dataset.type];

        if (this.dataset.type == "roads") {
          // Set Roads legend visibility (if Roads page)
          var roadSigns = document.querySelector(".road-signs").cloneNode(true);
          roadSigns.removeAttribute("hidden");
          embedBox.appendChild(roadSigns);

          // Disabled
          // api('roadAlerts', function( response ) {
          //   var parser = new DOMParser();
          //   var data = parser.parseFromString(response.trim(), 'text/xml');

          //   var h5 = document.createElement('h5');
          //   h5.innerHTML = 'Road Alerts (Icelandic only)';
          //   embedBox.appendChild( h5 );

          //   var day = data.createElement('h6');
          //   day.innerHTML = data.getElementsByTagName('dags')[0].innerHTML;
          //   embedBox.appendChild( day );

          //   var items = data.getElementsByTagName('item');
          //   for ( var i = 0; i < items.length; i++ ) {
          //     var item = items[i];

          //     var title = document.createElement('h6');
          //     title.innerHTML = item.getElementsByTagName('fyrirsogn')[0].innerHTML;
          //     embedBox.appendChild( title );

          //     var text = document.createElement('div');
          //     text.innerHTML = item.getElementsByTagName('texti')[0].innerHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
          //     embedBox.appendChild( text );
          //   }
          // });
        }
        showSpinnerWhileIFrameLoads();

        setupDropdownLists();
      }
    }

    function deleteTransient(transientId) {
      api(
        "deleteTransient",
        function(response) {
          console.log(response);
        },
        { transientId: transientId }
      );
    }

    function setupAurora(response) {
      var embedBox = document.querySelector(".embed-box");
      embedBox.innerHTML = "";

      try {
        // Add slider container
        var auroraSlider = document.createElement("div");
        auroraSlider.classList.add("aurora-slider");
        embedBox.appendChild(auroraSlider);

        // Parse response
        var parser = new DOMParser();
        var data = parser.parseFromString(response.trim(), "text/xml");
        var auroraRoot = data.getElementsByTagName("aurora")[0];
        var auroraForecastContainer = document.querySelector(
          ".aurora-forecast[hidden]"
        );

        // Add the 10 available days
        for (var i = 0; i < 10; i++) {
          var nightNode = auroraRoot.getElementsByTagName("night_data")[i];
          var sun = nightNode.getElementsByTagName("sun")[0];
          var moon = nightNode.getElementsByTagName("moon")[0];

          // Create night data object
          var dateArr = nightNode
            .getElementsByTagName("evening_date")[0]
            .innerHTML.split("-");
          var nightData = {
            activity_forecast: parseInt(
              nightNode.getElementsByTagName("activity_forecast")[0].innerHTML
            ),
            eveningDate: `${dateArr[2]}/${dateArr[1]}/${dateArr[0]}`,
            sunset: sun.getElementsByTagName("sunset")[0].innerHTML,
            darkness: sun.getElementsByTagName("darkness")[0].innerHTML,
            dawn: sun.getElementsByTagName("dawn")[0].innerHTML,
            sunrise: sun.getElementsByTagName("sunrise")[0].innerHTML,
            moonrise: moon.getElementsByTagName("moonrise")[0].innerHTML
          };

          // Populate Aurora template
          var auroraContainer = auroraForecastContainer.cloneNode(true);
          auroraContainer.removeAttribute("hidden");

          // Set up intensity indicators
          auroraContainer
            .querySelector(
              ".activity-value li:nth-child(" +
                (nightData["activity_forecast"] + 1) +
                ")"
            )
            .classList.add("active");
          var activityLabel = "";
          var activityClass = "";
          switch (nightData["activity_forecast"]) {
            case 0:
            case 1:
            case 2:
              activityLabel = __("Quiet");
              activityClass = "quiet";
              break;
            case 3:
            case 4:
            case 5:
              activityLabel = __("Medium");
              activityClass = "medium";
              break;
            case 6:
            case 7:
              activityLabel = __("High");
              activityClass = "high";
              break;
            case 8:
            case 9:
              activityLabel = __("Very High");
              activityClass = "very-high";
              break;
          }
          var activityLabelDOM = auroraContainer.querySelector(
            ".activity-label"
          );
          auroraContainer.querySelector(".active").classList.add(activityClass);
          activityLabelDOM.classList.add(activityClass);
          activityLabelDOM.innerHTML = activityLabel;

          // Set up time indicators
          auroraContainer.querySelector(".activity-date").innerHTML =
            nightData["eveningDate"];
          auroraContainer.querySelector(".sunset").innerHTML =
            nightData["sunset"];
          auroraContainer.querySelector(".darkness").innerHTML =
            nightData["darkness"];
          auroraContainer.querySelector(".dawn").innerHTML = nightData["dawn"];
          auroraContainer.querySelector(".sunrise").innerHTML =
            nightData["sunrise"];
          auroraContainer.querySelector(".moonrise").innerHTML =
            nightData["moonrise"];

          // Hide moon if data isn't available
          var moonOpacity = nightData["moonrise"].length ? "1" : "0";
          auroraContainer.querySelector(".moon-container").style =
            "opacity: " + moonOpacity + ";";

          auroraSlider.appendChild(auroraContainer);
        }

        // Init Slick slider
        $(".aurora-slider").slick({
          prevArrow:
            '<button class="slick-prev slick-arrow" aria-label="Previous" type="button">' +
            (window.language_code == "en" ? "Previous" : "Fyrri") +
            "</button>",
          nextArrow:
            '<button class="slick-next slick-arrow" aria-label="Next" type="button">' +
            (window.language_code == "en" ? "Next" : "Næsti") +
            "</button>"
        });

        var e = document.createElement("div");
        e.innerHTML = `
          <br>
          <img src="https://services.swpc.noaa.gov/images/aurora-forecast-northern-hemisphere.jpg" width="100%">
          <br><br><br>
          <img src="https://services.swpc.noaa.gov/images/swx-overview-small.gif" width="100%">
          <br><br>
      `;
        embedBox.appendChild(e);
      } catch (e) {
        // In case any problem happens
        // don't show aurora forecast
        // and request transient removal
        embedBox.innerHTML = "";
        var now = new Date();
        var formattedDate =
          now.getFullYear() +
          "_" +
          ("0" + (now.getMonth() + 1)).slice(-2) +
          "_" +
          ("0" + now.getDate()).slice(-2);
        deleteTransient("aurora_forecast_" + formattedDate);
      }

      var visibilityClouds = document
        .querySelector(".visibility-clouds")
        .cloneNode(true);
      visibilityClouds.removeAttribute("hidden");

      // Add extra iframes
      var iframeTemplate = document.createElement("iframe");
      iframeTemplate.height = "450";
      iframeTemplate.width = "100%";
      iframeTemplate.frameborder = "0";
      iframeTemplate.style = "margin-bottom: 1.5rem";

      var iframeVisibility = iframeTemplate.cloneNode(true);
      iframeVisibility.src =
        "https://embed.windy.com/embed2.html?lat=64.998&lon=-18.984&zoom=6&level=surface&overlay=visibility&menu=&message=true&marker=true&calendar=&pressure=&type=map&location=coordinates&detail=&detailLat=64.125&detailLon=-21.820&metricWind=m%2Fs&metricTemp=%C2%B0C&radarRange=-1";
      visibilityClouds
        .querySelector(".visibility")
        .appendChild(iframeVisibility);

      var iframeCloud = iframeTemplate.cloneNode(true);
      iframeCloud.src =
        "https://embed.windy.com/embed2.html?lat=64.998&lon=-18.984&zoom=5&level=surface&overlay=clouds&menu=&message=true&marker=true&calendar=&pressure=&type=map&location=coordinates&detail=&detailLat=64.125&detailLon=-21.820&metricWind=m%2Fs&metricTemp=%C2%B0C&radarRange=-1";
      visibilityClouds.querySelector(".clouds").appendChild(iframeCloud);

      embedBox.appendChild(visibilityClouds);

      // Add avalanche warnings
      api(
        "avalancheAlerts",
        function(response) {
          var avalancheAlerts = document.querySelector(
            ".avalanche-alerts .inner"
          );
          avalancheAlerts.parentNode.removeAttribute("hidden");

          var parser = new DOMParser();
          var data = parser.parseFromString(response.trim(), "text/xml");
          var avalancheRoot = data.getElementsByTagName("avalanche")[0];

          var avalancheConditions = avalancheRoot.getElementsByTagName(
            "conditions"
          )[0];
          var avalancheDescription = avalancheConditions.getElementsByTagName(
            "short_description"
          )[0];
          var p = document.createElement("p");
          p.style = "font-size: 1rem;";
          p.innerHTML = avalancheDescription.innerHTML;
          avalancheAlerts.appendChild(p);

          var avalancheWeather = avalancheRoot.getElementsByTagName(
            "weather_forecast"
          )[0];
          var avalancheWeatherForecast = avalancheWeather.getElementsByTagName(
            "forecast"
          )[0];
          var p2 = document.createElement("p");
          p2.style = "font-size: 1rem;";
          p2.innerHTML = avalancheWeatherForecast.innerHTML;
          avalancheAlerts.appendChild(p2);
        },
        { language_code: window.language_code }
      );
    }

    function getActiveLocationId() {
      return (
        app.server_data["activeLocationId"] ||
        app.selectCity.querySelector("option").getAttribute("value")
      );
    }

    function formatDate(date) {
      return `${("0" + date.getDate()).slice(-2)}/${(
        "0" +
        (date.getMonth() + 1)
      ).slice(-2)}/${date.getFullYear()}`;
    }
  };
})();
